/* NO DECORUM — motion layer. Pairs with assets/nd-motion.css.
   Reveal on scroll (rise, words, stagger, wipe, write, slap, draw, line),
   first-visit opening, hero drift, frame parallax, image fade-in and the
   oversized footer wordmark. No dependencies; everything is an enhancement. */
(function () {
  'use strict';

  var win = window;
  var doc = document;
  var root = doc.documentElement;

  if (win.__ndMotionT) clearTimeout(win.__ndMotionT);

  var ON = root.classList.contains('nd-motion') && 'IntersectionObserver' in win;
  if (!ON) {
    root.classList.remove('nd-motion');
    root.classList.remove('nd-intro-on');
  }

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------------- Images fade in when they arrive ---------------- */

  function imgs(ctx) {
    qsa('img.nd-img:not(.is-loaded)', ctx).forEach(function (img) {
      if (img.__ndImg) return;
      img.__ndImg = 1;
      var done = function () { img.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  /* ---------------- Footer wordmark (shown with or without motion) ---------------- */

  function buildGiant(ctx) {
    qsa('[data-nd-giant]', ctx).forEach(function (host) {
      if (host.querySelector('.nd-giant')) return;
      var text = (host.getAttribute('data-nd-giant') || '').trim();
      if (!text || text.length > 16) return;
      var g = doc.createElement('div');
      g.className = 'nd-giant';
      g.setAttribute('aria-hidden', 'true');
      text.split('').forEach(function (ch, i) {
        var o = doc.createElement('span');
        o.className = 'nd-giant__l';
        var s = doc.createElement('span');
        s.style.setProperty('--i', i);
        s.textContent = ch === ' ' ? String.fromCharCode(160) : ch;
        o.appendChild(s);
        g.appendChild(o);
      });
      host.appendChild(g);
      if (ON) g.setAttribute('data-nd', 'letters');
    });
    fitGiant();
  }

  function fitGiant() {
    qsa('.nd-giant').forEach(function (g) {
      var host = g.parentNode;
      var cs = getComputedStyle(host);
      var avail = host.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (!(avail > 0)) return;
      g.style.fontSize = '100px';
      var natural = 0;
      qsa('.nd-giant__l', g).forEach(function (l) { natural += l.getBoundingClientRect().width; });
      if (!(natural > 0)) return;
      g.style.fontSize = (avail * 0.985 / natural * 100).toFixed(2) + 'px';
    });
  }

  if (!ON) {
    var still = function () { buildGiant(doc); };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', still);
    else still();
    win.addEventListener('resize', fitGiant);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fitGiant);
    win.NDMotion = { scan: function () {}, on: false };
    return;
  }

  /* ---------------- Reveal on scroll ---------------- */

  function splitWords(el) {
    var count = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var parts = ch.nodeValue.split(/(\s+)/);
          var frag = doc.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
            var outer = doc.createElement('span');
            outer.className = 'nd-w';
            outer.style.setProperty('--i', count++);
            var inner = doc.createElement('span');
            inner.className = 'nd-w__i';
            inner.textContent = part;
            outer.appendChild(inner);
            frag.appendChild(outer);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && !/^(br|svg)$/i.test(ch.tagName) && !ch.classList.contains('nd-w')) {
          walk(ch);
        }
      });
    })(el);
    return count;
  }

  var pending = [];   /* clipped things are watched by position */
  var opening = [];   /* hero copy opens in reading order on load */
  var ready = false;

  var io = new IntersectionObserver(function (entries) {
    var hits = [];
    entries.forEach(function (e) { if (e.isIntersecting) hits.push(e); });
    if (!hits.length) return;
    hits.sort(function (a, b) {
      var ta = Math.round(a.boundingClientRect.top / 12), tb = Math.round(b.boundingClientRect.top / 12);
      return (ta - tb) || (a.boundingClientRect.left - b.boundingClientRect.left);
    });
    hits.forEach(function (e, i) {
      io.unobserve(e.target);
      show(e.target, Math.min(i, 6) * 90);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

  function show(el, delay) {
    var base = parseInt(el.getAttribute('data-nd-d') || '0', 10) || 0;
    var total = base + delay;
    el.style.setProperty('--nd-d', total + 'ms');
    el.classList.add('is-in');
    var type = el.getAttribute('data-nd');
    if (type === 'letters') return;
    /* hand the element back to normal styling once it has arrived, so hovers are free */
    var extra = (el.__ndWords || 0) * (type === 'censor' ? 95 : 70) + (el.__ndKids || 0) * 75 + (type === 'write' ? 600 : 0) + (type === 'censor' ? 500 : 0);
    setTimeout(function () {
      el.removeAttribute('data-nd');
      el.classList.remove('is-in');
      el.style.removeProperty('--nd-d');
    }, total + extra + 1700);
  }

  function tag(el) {
    if (el.__nd) return;
    el.__nd = 1;
    var type = el.getAttribute('data-nd');
    if (type === 'words' || type === 'censor') el.__ndWords = splitWords(el);
    if (type === 'stagger') {
      var kids = Array.prototype.slice.call(el.children);
      kids.forEach(function (k, i) { if (!k.style.getPropertyValue('--i')) k.style.setProperty('--i', Math.min(i, 12)); });
      el.__ndKids = Math.min(kids.length, 12);
    }
    if (type === 'draw') qsa('path', el).forEach(function (p) { p.setAttribute('pathLength', '1'); });
    if (el.closest('.nd-hero')) { opening.push(el); return; }
    if (type === 'wipe') pending.push(el);
    else io.observe(el);
  }

  function scan(ctx) {
    qsa('[data-nd]:not([data-nd="letters"])', ctx).forEach(tag);
    qsa('.nd-giant[data-nd="letters"]', ctx).forEach(function (el) {
      if (el.__nd) return;
      el.__nd = 1;
      io.observe(el);
    });
    imgs(ctx);
    if (ready) openHero();
  }

  function openHero() {
    if (!opening.length) return;
    var list = opening.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    opening = [];
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        list.forEach(function (el, i) { show(el, 140 + Math.min(i, 7) * 110); });
      });
    });
  }

  /* ---------------- Scroll-linked pieces, one shared frame loop ---------------- */

  var items = [];
  var rafId = 0;

  function checkPending(vh) {
    if (!pending.length) return;
    var hits = [], rest = [];
    pending.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width && r.top < vh * 0.92 && r.bottom > 0) hits.push({ el: el, top: Math.round(r.top / 12), left: r.left });
      else rest.push(el);
    });
    if (!hits.length) return;
    pending = rest;
    hits.sort(function (a, b) { return (a.top - b.top) || (a.left - b.left); });
    hits.forEach(function (h, i) { show(h.el, Math.min(i, 6) * 120); });
  }

  function frame() {
    rafId = 0;
    var vh = win.innerHeight;
    var i;
    checkPending(vh);
    for (i = 0; i < items.length; i++) items[i].read(vh);
    for (i = 0; i < items.length; i++) items[i].write(vh);
  }
  function kick() { if (!rafId) rafId = requestAnimationFrame(frame); }

  /* --p: 0 as a frame enters at the bottom of the screen, 1 as it leaves the top */
  function parallax(el) {
    var p = 0.5, vis = false, last = -1;
    items.push({
      read: function (vh) {
        var r = el.getBoundingClientRect();
        vis = r.bottom > -80 && r.top < vh + 80;
        if (vis) p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      },
      write: function () {
        if (vis && Math.abs(p - last) > 0.0005) { last = p; el.style.setProperty('--p', p.toFixed(4)); }
      }
    });
  }

  /* --hp: how far the hero has scrolled out of the top of the screen */
  function heroDrift(el) {
    var p = 0, vis = true, last = -1;
    items.push({
      read: function (vh) {
        var r = el.getBoundingClientRect();
        vis = r.bottom > -80 && r.top < vh;
        if (vis && r.height > 0) p = clamp(-r.top / r.height, 0, 1);
      },
      write: function () {
        if (vis && Math.abs(p - last) > 0.0005) { last = p; el.style.setProperty('--hp', p.toFixed(4)); }
      }
    });
  }

  function link(ctx) {
    qsa('.nd-hero', ctx).forEach(function (el) { if (!el.__ndl) { el.__ndl = 1; heroDrift(el); } });
    qsa('[data-nd-par]', ctx).forEach(function (el) { if (!el.__ndl) { el.__ndl = 1; parallax(el); } });
    kick();
  }

  /* ---------------- First-visit opening ---------------- */

  function intro() {
    var el = doc.querySelector('.nd-intro');
    if (!root.classList.contains('nd-intro-on') || !el) {
      root.classList.remove('nd-intro-on');
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        doc.removeEventListener('keydown', finish);
        try { sessionStorage.setItem('ndIntro', '1'); } catch (e) {}
        el.classList.add('is-out');
        setTimeout(resolve, 380); /* the page starts opening while the curtain lifts */
        setTimeout(function () {
          root.classList.remove('nd-intro-on');
          el.classList.remove('is-out');
          el.classList.remove('is-play');
          doc.dispatchEvent(new CustomEvent('nd:intro-done'));
        }, 1000);
      }
      requestAnimationFrame(function () { el.classList.add('is-play'); });
      var timer = setTimeout(finish, 2250);
      el.addEventListener('click', finish);
      doc.addEventListener('keydown', finish);
    });
  }

  /* ---------------- Start ---------------- */

  function start() {
    try {
      buildGiant(doc);
      scan(doc);
      link(doc);
      intro().then(function () {
        ready = true;
        root.classList.add('nd-ready');
        openHero();
        kick();
      });
    } catch (e) {
      root.classList.remove('nd-motion');
      root.classList.remove('nd-intro-on');
    }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();

  /* capture on the document: Horizon can scroll an inner wrapper on some layouts */
  doc.addEventListener('scroll', kick, { capture: true, passive: true });
  win.addEventListener('resize', function () { fitGiant(); kick(); });
  win.addEventListener('load', function () { fitGiant(); kick(); });
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { fitGiant(); kick(); });

  /* other scripts (load-more, recommendations) call this after adding content */
  win.NDMotion = {
    on: true,
    scan: function (ctx) { scan(ctx || doc); link(ctx || doc); }
  };

  /* Theme editor: a section was added or re-rendered */
  doc.addEventListener('shopify:section:load', function (e) {
    buildGiant(e.target);
    scan(e.target);
    link(e.target);
  });
})();
